import { on, select, selectAll } from 'modules/dom'
import { map } from 'modules/utils'

const BUTTON_DOWNLOAD_SELECTOR = '.js-download-pdf'
const BUTTON_PLAY_VIDEO_SELECTOR = '.js-icon-play'

export default function(el) {
  const buttonPlayVideoEl = select(BUTTON_PLAY_VIDEO_SELECTOR, el)
  const buttonDownloadEls = selectAll(BUTTON_DOWNLOAD_SELECTOR, el)
  if (buttonDownloadEls) {
    map((item) => {
      on('click', function () {
        if(typeof ga !== 'undefined') {
          ga('send', 'event', 'Downloads', 'Click', 'Ebook downloaded', '0');
        }
      }, item)
    }, buttonDownloadEls)
  }

  if (buttonPlayVideoEl) {
    on('click', function () {
      if(typeof ga !== 'undefined') {
        ga('send', 'event', 'Videos', 'Click', 'Play Video', '0');
      }
    }, buttonPlayVideoEl)
  }
}
